import React from "react";
import { Common } from "../dataprovider";

export const InvalidPaymentLinkComponent: React.FunctionComponent<any> = (props: any) => {

    return (
        <div className="invalidPaymentLinkMessage"><h1>{Common.ApplicationLabels.Error_Message_InvalidPaymentLink}</h1></div>
    );
}